import React, { useState } from "react";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";
import TEXT from "../../utils/text/glossary.json";
import BIDModal from "../reusable/BIDModal/BIDModal";

export default function GlossaryModal({ children }) {
  const { language } = useCurrentLanguage();
  const [isModalOpen, setIsModalOpen] = useState(false);

  function showModal() {
    setIsModalOpen(true);
  }

  function handleCancel() {
    setIsModalOpen(false);
  }

  return (
    <>
      <button onClick={showModal} className="noformat-button">
        {children}
      </button>
      <BIDModal
        title={TEXT["title"][language]}
        visible={isModalOpen}
        onCancel={handleCancel}
      >
        {TEXT["terms"].map((term, key) => {
          return (
            <p key={key}>
              <strong>{term["term"][language]}: </strong>
              {term["definition"][language]}
            </p>
          );
        })}
      </BIDModal>
    </>
  );
}
